import { render, staticRenderFns } from "./FrmManageClients.vue?vue&type=template&id=2a514dd9"
import script from "./FrmManageClients.vue?vue&type=script&lang=js"
export * from "./FrmManageClients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports